import { Addon as MarketplaceAddon } from '@galaxy/marketplace-apps/v1';
import { App as MarketplaceApp, AppType as MarketplaceAppType } from '@vendasta/marketplace-apps';
import { Package as MarketplacePackage } from '@vendasta/marketplace-packages';
import { InventoryItemAddon, InventoryItemApp, InventoryItemBase, InventoryItemPackage } from '../item-types';

export function fromMarketplaceApp(mp: MarketplaceApp): InventoryItemApp | InventoryItemAddon {
  const baseItem: InventoryItemBase = {
    itemId: mp.key.appId,
    name: mp.sharedMarketingInformation?.name,
    iconUrl: mp.sharedMarketingInformation?.iconUrl,
    type: 'app',
    quantity: 1,
  };

  if (mp.appType === MarketplaceAppType.APP_TYPE_ADDON) {
    return {
      ...baseItem,
      type: 'addon',
      parentItemId: mp.parentRequirements?.parentDetails?.key?.appId,
    };
  }

  let edition: InventoryItemApp['edition'];
  const usesEditions = mp.key?.editionId != null;
  if (usesEditions) {
    edition = {
      editionId: mp.key?.editionId ?? '',
      name: mp.sharedMarketingInformation?.editionName ?? '',
    };
  }

  return {
    ...baseItem,
    type: 'app',
    edition: edition,
  };
}

export function fromMarketplaceAddon(addon: MarketplaceAddon): InventoryItemAddon {
  return {
    itemId: addon.addonId,
    type: 'addon',
    name: addon.productName,
    iconUrl: addon.icon,
    parentItemId: addon.appId,
    quantity: 1,
  };
}

export function fromMarketplacePackage(marketplacePackage: MarketplacePackage): InventoryItemPackage {
  return {
    itemId: marketplacePackage.packageId,
    type: 'package',
    name: marketplacePackage.name,
    iconUrl: marketplacePackage.icon,
    quantity: 1,
  };
}
